import './css/BlogAllNewsMenu.css';
import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { PiX } from 'react-icons/pi';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const BlogAllNewsMenu = ({ isActive, handleTogleMenu }) => {
  const { search } = useLocation();

  const [active, setActive] = useState(0);
  const history = useHistory();
  const { lang } = useParams();

  const newList = [
    // {
    //   name: 'Blog',
    //   link: 'index',
    // },
    {
      name: 'Todas las noticias',
      link: 'all-articles',
    },
    {
      name: 'Inteligencia artificial',
      link: 'artificial-intelligence',
    },
    {
      name: 'Cine',
      link: 'cinema',
    },
    {
      name: 'Equipo audiovisual',
      link: 'audiovisual-equipment',
    },
    {
      name: 'Producción audiovisual',
      link: 'audiovisual-post-production',
    },
  ];
  const handleClick = (link, num) => {
    setActive(num);
    history.push('/' + lang + '/blog/search?category=' + link);
  };
  const [isDisplayingPhone, setIsDisplayingPhone] = useState(false);
  return (
    <div className={`BlogAllNewsMenu ${!isActive && 'hidden'}`}>
      <div
        onClick={() => {
          handleTogleMenu();
        }}
        className="each_blog_container close_button"
      >
        <PiX />
      </div>
      {newList.map(({ link, name }, index) => (
        <div
          key={name + 'index'}
          onClick={() => {
            handleClick(link, index);
          }}
          className={index == active ? 'active_each_blog_container' : 'each_blog_container'}
        >
          {name}
        </div>
      ))}
    </div>
  );
};

export default BlogAllNewsMenu;
